import { useState } from "react";

export const useExportToXLS = (app) => {
  const [loadingExcel, setLoadingExcel] = useState(false);

  const exportToXLS = async (objectId, exportContainer) => {
    try {
      let id = objectId;

      if (exportContainer) {
        const vis = await app.visualization.get(objectId);
        if (vis?.model?.items?.activeId) {
          id = vis.model.items.activeId;
        }
      }

      if (app && id) {
        setLoadingExcel(true);
        const vis = await app.visualization.get(id);

        const link = await vis.table.exportData({
          format: "OOXML",
          state: "A",
          filename: `export_${id}`,
        });

        const downloadUrl = `https://qsense.mtrix.com.br${
          process.env.REACT_APP_PREFIX || ""
        }${link.substring(link.indexOf("tempcontent"))}`;

        const tempLink = document.createElement("a");
        tempLink.href = downloadUrl;
        tempLink.setAttribute("download", `export_${id}.xlsx`);
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }
    } catch (error) {
      console.error("Erro ao exportar para XLS:", error);
    } finally {
      setLoadingExcel(false);
    }
  };

  return { exportToXLS, loadingExcel };
};
